import "./style.css";

import "./tailwind.css";

import React from "react";
import { AppSidebar } from "@/components/app-sidebar";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";
import { PocketProvider, usePocket } from "@/contexts/PocketContext";
import { CityProvider } from "@/contexts/CityContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { NuqsAdapter } from 'nuqs/adapters/react';
import { Breadcrumbs } from "@/components/Breadcrumbs";

function Layout({ children }: { children: React.ReactNode }) {
  const { user } = usePocket();

  return (
    <SidebarProvider>
      {user && <AppSidebar />}
      <SidebarInset>
        {user && (
          <header className="flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12">
            <div className="flex items-center gap-2 px-4">
              <SidebarTrigger className="-ml-1" />
              <Separator orientation="vertical" className="mr-2 h-4" />
              <Breadcrumbs />
            </div>
          </header>
        )}
        <div className="flex flex-1 flex-col gap-4 p-4 pt-0">{children}</div>
      </SidebarInset>
    </SidebarProvider>
  );
}

export default function LayoutDefault({ children }: { children: React.ReactNode }) {
  return (
    <NuqsAdapter>
      <PocketProvider>
        <AuthProvider>
          <CityProvider>
            <Layout>{children}</Layout>
          </CityProvider>
        </AuthProvider>
      </PocketProvider>
    </NuqsAdapter>
  );
}
